<template>
  <div :class="$style.loadingBox">
    <LoadingMobile :class="$style.loading" />
    <img src="./assets/light_icon.png" :class="$style.light" />
    <div :class="$style.tips">{{ $t("6fb2ee95a6") }}</div>
  </div>
</template>
<script>
import { LoadingMobile } from '@/components/Loading'
export default {
  name: 'LoadingBox',
  components: {
    LoadingMobile
  }
}
</script>
<style lang="scss" module>
.loadingBox {
  margin: auto;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.04);
  border-radius: 2px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  user-select: none;
  text-align: center;
}

.loading {
  margin: 80px auto 0;
}

.light {
  width: 16px;
  height: 16px;
  margin-top: 24px;
}

.tips {
  margin: 9px 30px 30px;
  color: #000;
  font-size: 12px;
  line-break: 19px;
}
</style>
